import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryCard } from '@feathr/components';
import { localTime, TimeFormat } from '@feathr/hooks';

interface IMetaConnectionDetailsProps {
  businessName: string;
  connectedOn: Date;
  username: string;
}

function MetaConnectionDetails({
  businessName,
  connectedOn,
  username,
}: Readonly<IMetaConnectionDetailsProps>): JSX.Element {
  const { t } = useTranslation();

  const formattedDate = localTime(connectedOn.toISOString(), TimeFormat.longDateTime);

  return (
    <SummaryCard>
      <SummaryCard.Header>{t('Connection Details')}</SummaryCard.Header>
      <SummaryCard.Item label={t('Business Manager')}>{businessName}</SummaryCard.Item>
      <SummaryCard.Item label={t('Username')}>{username}</SummaryCard.Item>
      <SummaryCard.Item icon={faCalendar} label={t('Connected On')}>
        {formattedDate}
      </SummaryCard.Item>
    </SummaryCard>
  );
}

export default MetaConnectionDetails;
